import React from "react"
import {Link, withPrefix} from "gatsby"
import Layout from "@layout/layout"
import {pl, en} from "@content/pages/support-fundation.yaml"
import HeaderSubpage from "@layout/header-subpage"
import SEO from "@layout/seo"

export default ({isEn}) => {
  const translation = isEn ? en : pl

  return (
    <Layout isEn={isEn}>
      <SEO
        isEn={isEn}
        title={translation.metaTitle}
        description={translation.metaDescription}
      />
      <HeaderSubpage isEn={isEn}/>
      <section
        className="section wrapper text-center imgbg"
        style={{
          backgroundImage: `url(${withPrefix("images/help/hero.jpg")})`,
        }}
      >
        <section className="padding">
          <div className="row">
            <div className="large-6 large-centered medium-12 small-12 columns">
              <form
                data-abide="motn59-abide"
                method="post"
                action="https://donate.sasafoundation.com"
                id="donate_form"
                noValidate
              >
                <input
                  type="hidden"
                  name="input-lang"
                  id="input-lang"
                  defaultValue="pl"
                />
                <h1
                  className="large margin-bottom50 wow fadeInUp"
                  data-wow-duration="1.5s"
                  style={{
                    visibility: "hidden",
                  }}
                >
                  {isEn ? 'Support foundation' : 'Wspomóż fundację'}

                </h1>
                <p className="margin-bottom50">
                  <img
                    src={withPrefix("images/help/white_heart.svg")}
                    alt="pomoc dla potrzebujących"
                  />
                </p>
                <p className="margin-bottom50"/>
                <p>
                  {isEn ? 'Be part of better healthcare worldwide' : 'Przyczyń się do poprawy poziomu leczenia na świecie!'}

                </p>
                <p/>
                <div
                  className="margin-bottom50 wow fadeInUp"
                  data-wow-duration="1.5s"
                  style={{
                    visibility: "hidden",
                  }}
                >
                  <br/>
                  <br/>
                  <h5 className="big">
                    {isEn ? 'Pick payment type' : 'Wybierz sposób płatności'}
                  </h5>
                  <span className="form-error" data-form-error-for="operator">
                    {isEn ? 'Pick operator' : 'Wybierz operatora!'}
                  </span>
                  <div className="row small-up-1 medium-up-3 large-up-3 metoda_platnosci">
                    <div className="column ">
                      <span
                        className="button expanded whiteborder pay"
                        id="payu"
                      >
                        <strong>PayU</strong>
                      </span>
                    </div>
                    <div className="column ">
                      <span
                        className="button expanded whiteborder pay"
                        id="paypal"
                      >
                        <strong>PayPal</strong>
                      </span>
                    </div>
                    <div className="column end">
                      <span
                        className="button expanded whiteborder pay"
                        id="przelew"
                      >
                        <strong>Przelew</strong>
                      </span>
                    </div>
                  </div>
                  <input
                    className="hide"
                    name="operator"
                    id="operator"
                    required
                  />
                </div>
                <div
                  className="margin-bottom50 wow fadeInUp"
                  data-wow-duration="1.5s"
                  style={{
                    visibility: "hidden",
                  }}
                >
                  <h5 className="big">
                    {isEn ? `How much money you want to spend to support us` : 'jaką kwotę chcesz przeznaczyć?'}
                  </h5>
                  <span className="form-error" data-form-error-for="kwota">
                    {isEn ? 'Pick amount of money' : 'Wybierz lub wpisz kwotę!'}
                  </span>
                  <div className="row small-up-3 medium-up-5 large-up-5 kwota_platnosci">
                    <div className="column ">
                      <span className="button expanded whiteborder pay">
                        <strong>10</strong>
                      </span>
                    </div>
                    <div className="column ">
                      <span className="button expanded whiteborder pay">
                        <strong>20</strong>
                      </span>
                    </div>
                    <div className="column ">
                      <span className="button expanded whiteborder pay">
                        <strong>50</strong>
                      </span>
                    </div>
                    <div className="column ">
                      <span className="button expanded whiteborder pay">
                        <strong>100</strong>
                      </span>
                    </div>
                    <div className="column end">
                      <span className="button expanded whiteborder pay">
                        <strong>200</strong>
                      </span>
                    </div>
                  </div>
                  <input
                    className="hide"
                    name="kwota"
                    id="kwota"
                    defaultValue
                    required
                  />
                </div>
                <div className="row">
                  <div className="large-6 large-centered medium-12 small-12 columns text-center">
                    <p
                      className="margin-bottom50 wow fadeInUp"
                      data-wow-duration="1.5s"
                      style={{visibility: "hidden"}}
                    >
                      <span className="input input--madoka">
                        <input
                          className="input__field input__field--madoka"
                          type="text"
                          id="input-kwota"
                          pattern="number"
                        />
                        <label
                          className="input__label input__label--madoka"
                          htmlFor="input-kwota"
                        >
                          <svg
                            className="graphic graphic--madoka"
                            width="100%"
                            height="100%"
                            viewBox="0 0 404 77"
                            preserveAspectRatio="none"
                          >
                            <path d="m0,0l404,0l0,77l-404,0l0,-77z"/>
                          </svg>
                          <span className="input__label-content input__label-content--madoka">
                            {isEn ? 'or write the amount yourserlf' : 'lub wpisz samodzielnie'}
                          </span>
                        </label>
                      </span>
                    </p>
                  </div>
                </div>
                <div style={{display: "none"}} id="przelew_box">
                  <div className="column">
                    <p>
                      Dane do przelewu:
                      <br/>
                      Bank PKOBP 27 1020 1013 0000 0302 0331 1040
                      <br/>
                      Kod BIC (Swift): BPKOPLPW
                    </p>
                    <p>
                      {isEn ?
                        `
                        With transactions from other countries please add bill number in IBAN format (i.e. with PL prefix):
                      <br/>
                      PL 27 1020 1013 0000 0302 0331 1040
                        `
                        : `Przy przelewach z zagranicy należy wpisać numer rachunku w
                      formacie IBAN (tzn. z dopiskiem z przodu PL):
                      <br/>
                      PL 27 1020 1013 0000 0302 0331 1040`
                      }

                    </p>
                    <p>
                      Fundacja SASA
                      <br/>
                      ul. Przechodnia 2/115
                      <br/>
                      00-100 Warszawa
                    </p>
                    <p>
                      {isEn ?
                        `In title please write: "Darowizna dla fundacji SASA", and contact to you(e-mail, tel).). <br/>
                         Please fill in form below, which is information for foundation about donation.` :
                        `W tytule przelewu prosimy wpisać: “Darowizna dla fundacji
                      SASA” oraz kontakt do siebie (e-mail, tel.).
                      <br/>
                      Prosimy o uzupełnienie poniższego formularza, który
                      stanowi informację dla Fundacji o dokonanej wpłacie*`}
                    </p>
                  </div>
                </div>
                {!isEn &&
                <div style={{display: "none"}} id="podatek_box">
                  <div className="column">
                    <p>
                      Dane do przelewu na 1%:
                      <br/>
                      Bank PKOBP 27 1020 1013 0000 0302 0331 1040
                      <br/>
                      Kod BIC (Swift): BPKOPLPW
                    </p>
                    <p>
                      Przy przelewach z zagranicy należy wpisać numer rachunku w
                      formacie IBAN (tzn. z dopiskiem z przodu PL):
                      <br/>
                      PL 27 1020 1013 0000 0302 0331 1040
                    </p>
                    <p>
                      Fundacja SASA
                      <br/>
                      ul. Przechodnia 2/115
                      <br/>
                      00-100 Warszawa
                    </p>
                    <p>
                      W tytule przelewu prosimy wpisać: “Darowizna dla fundacji
                      SASA” oraz kontakt do siebie (e-mail, tel.).
                      <br/>
                      Prosimy o uzupełnienie poniższego formularza, który
                      stanowi informację dla Fundacji o dokonanej wpłacie*
                    </p>
                  </div>
                </div>
                }
                <div
                  className="wow fadeInUp"
                  data-wow-duration="1.5s"
                  style={{visibility: "hidden"}}
                >
                  <h5 className="big">{isEn ? 'Fill in form data' : 'uzupełnij dane' }</h5>
                  <div className="row small-up-1 medium-up-2 large-up-2">
                    <div className="column">
                      <p className="margin-bottom50">
                        <span className="input input--madoka">
                          <input
                            className="input__field input__field--madoka"
                            type="text"
                            id="input-imie"
                            name="input-imie"
                            required
                          />
                          <label
                            className="input__label input__label--madoka"
                            htmlFor="input-imie"
                          >
                            <svg
                              className="graphic graphic--madoka"
                              width="100%"
                              height="100%"
                              viewBox="0 0 404 77"
                              preserveAspectRatio="none"
                            >
                              <path d="m0,0l404,0l0,77l-404,0l0,-77z"/>
                            </svg>
                            <span className="input__label-content input__label-content--madoka">
                              {isEn ? 'firstname' : 'imię'}
                            </span>
                            <span
                              className="form-error"
                              data-form-error-for="input-imie"
                            >
                              {isEn ? 'firstname is obligatory' : 'Imię jest obowiązkowe!' }
                            </span>
                          </label>
                        </span>
                      </p>
                    </div>
                    <div className="column">
                      <p className="margin-bottom50">
                        <span className="input input--madoka">
                          <input
                            className="input__field input__field--madoka"
                            type="text"
                            id="input-nazwisko"
                            name="input-nazwisko"
                            required
                          />
                          <label
                            className="input__label input__label--madoka"
                            htmlFor="input-nazwisko"
                          >
                            <svg
                              className="graphic graphic--madoka"
                              width="100%"
                              height="100%"
                              viewBox="0 0 404 77"
                              preserveAspectRatio="none"
                            >
                              <path d="m0,0l404,0l0,77l-404,0l0,-77z"/>
                            </svg>
                            <span className="input__label-content input__label-content--madoka">
                              {isEn ? 'lastname' : 'nazwisko'}
                            </span>
                            <span className="form-error">
                              {isEn ? 'Lastname is obligatory!' : 'Nazwisko jest obowiązkowe!'}
                            </span>
                          </label>
                        </span>
                      </p>
                    </div>
                    <div className="column">
                      <p className="margin-bottom50">
                        <span className="input input--madoka">
                          <input
                            className="input__field input__field--madoka"
                            type="email"
                            id="input-email"
                            name="input-email"
                            required
                          />
                          <label
                            className="input__label input__label--madoka"
                            htmlFor="input-email"
                          >
                            <svg
                              className="graphic graphic--madoka"
                              width="100%"
                              height="100%"
                              viewBox="0 0 404 77"
                              preserveAspectRatio="none"
                            >
                              <path d="m0,0l404,0l0,77l-404,0l0,-77z"/>
                            </svg>
                            <span className="input__label-content input__label-content--madoka">
                              {isEn ? 'email' : 'email'}

                            </span>
                            <span
                              className="form-error"
                              data-form-error-for="input-email"
                            >
                              {isEn ? 'Email is obligatory!' : 'Email jest obowiązkowy!'}
                            </span>
                          </label>
                        </span>
                      </p>
                    </div>
                    <div className="column">
                      <p className="margin-bottom50">
                        <span className="input input--madoka">
                          <input
                            className="input__field input__field--madoka"
                            type="email"
                            id="input-emailagain"
                            required
                            data-equalto="input-email"
                          />
                          <label
                            className="input__label input__label--madoka"
                            htmlFor="input-emailagain"
                          >
                            <svg
                              className="graphic graphic--madoka"
                              width="100%"
                              height="100%"
                              viewBox="0 0 404 77"
                              preserveAspectRatio="none"
                            >
                              <path d="m0,0l404,0l0,77l-404,0l0,-77z"/>
                            </svg>
                            <span className="input__label-content input__label-content--madoka">
                              {isEn ? 'repeat mail' : 'powtórz email'}

                            </span>
                            <span className="form-error">
                              {isEn ? 'Email addresses must be the same' : 'Adresy email muszą być takie same!'}
                            </span>
                          </label>
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
                <div
                  className="margin-bottom50 wow fadeInUp"
                  data-wow-duration="1.5s"
                  style={{visibility: "hidden"}}
                >
                  <div className="row">
                    <div className="large-1 medium-1 small-1 columns text-right">
                      <input type="checkbox" id="wyrazam-zgode" required/>
                    </div>
                    <div className="large-11 medium-11 small-11 columns text-left">
                      <label
                        className="small white dane-osobowe"
                        htmlFor="wyrazam-zgode"
                      >
                        {
                          isEn ? `
                          I accept processing my personal data by SASA Foundation, to send information about our actions and donating events
                          organised by foundation, according to bill from 29 august 1997, about security of private data (Dz. U. Nr 133, poz.
                        833) *
                          ` : `
                          Wyrażam zgodę na przetwarzanie moich danych osobowych
                        przez Fundację SASA w celu przesyłania informacji o
                        działalności Fundacji i organizowanych przez Fundację
                        akcjach zbiórkowych, zgodnie z Ustawą z dnia 29 sierpnia
                        1997 r. o ochronie danych osobowych (Dz. U. Nr 133, poz.
                        833) *`
                        }
                      </label>
                    </div>
                  </div>
                </div>
                <a
                  href
                  id="send_form"
                  className="rollover margin-bottom50 wow fadeInUp"
                  data-wow-duration="1.5s"
                  style={{visibility: "hidden"}}
                >
                  <span className="underlined">
                    <span className="roll-icon">
                      <svg
                        version="1.1"
                        id="heart"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        width="65.583px"
                        height="59.917px"
                        viewBox="2.509 5.333 65.583 59.917"
                        enableBackground="new 2.509 5.333 65.583 59.917"
                        xmlSpace="preserve"
                      >
                        <path
                          fill="#7D3852"
                          d="M66.789,16.872c-2.182-1.733-9.911-7.901-12.147-9.408
								c-0.996-0.67-1.724-0.958-2.468-1.005c-0.75,0.026-1.543,0.293-2.558,0.937c-2.354,1.501-11.717,8.557-13.529,9.922
								c-0.501-0.397-11.054-8.8-13.556-10.487c-0.996-0.67-1.842-0.958-2.586-1.005c-0.75,0.026-1.599,0.293-2.613,0.937
								C14.722,8.425,3.467,16.914,3.467,16.914s-0.248,0.158-0.248,1.003c0,0.757-0.051,20.364-0.051,24.099
								c0,0.647,0.467,1.118,0.748,1.329C7.445,45.995,31.43,62.099,33.804,63.7c0.996,0.669,1.847,0.958,2.592,1.005
								c0.749-0.026,1.604-0.293,2.619-0.937c2.61-1.663,26.481-19.123,27.276-19.773c1.375-1.125,1.209-3.089,1.209-3.089V18.658
								C67.5,18.658,67.291,17.27,66.789,16.872z M38.567,59.825c-0.708,0.61-1.439,0.855-2.118,0.86c-0.675-0.02-1.402-0.288-2.093-0.914
								c-0.194-0.177-19.101-12.56-27.284-18.623C6.959,41.064,6.5,40.84,6.5,39.968c0-3.521,0-19.452,0-20.146
								c0-0.793,0.076-0.74,0.9-1.336c4.234-3.064,10.1-7.641,10.264-7.781c0.709-0.61,1.498-0.855,2.178-0.86
								c0.674,0.02,1.432,0.288,2.121,0.914c0.196,0.179,8.695,6.905,12.336,9.893c1.565,1.283,2.18,1.024,3.096,0.367
								c3.747-2.688,12.522-9.507,12.725-9.679c0.708-0.61,1.443-0.855,2.122-0.86c0.675,0.02,1.401,0.288,2.092,0.914
								c0.159,0.146,5.067,4.72,9.161,7.956c0.174,0.136,0.213,21.679,0.057,21.796C55.711,47.09,38.765,59.657,38.567,59.825z"
                        />
                      </svg>
                      <svg
                        version="1.1"
                        id="arrow"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        width="17.207px"
                        height="35.079px"
                        viewBox="0 0 17.207 35.079"
                        enableBackground="new 0 0 17.207 35.079"
                        xmlSpace="preserve"
                      >
                        <path
                          fill="#871A51"
                          d="M4.87,35.079c0,0,9.407-11.824,11.259-14.572c0.719-1.067,1.027-1.979,1.078-2.776
								c-0.028-0.804-0.314-1.721-1.004-2.808c-1.782-2.797-10.88-14.86-10.88-14.86L0.454,0c0.033,0.637,11.293,15.133,11.523,15.401
								c0.654,0.76,0.917,1.543,0.922,2.271l0,0c-0.021,0.723-0.31,1.503-0.979,2.242C11.679,20.179,0.052,34.382,0,35.013L4.87,35.079z"
                        />
                      </svg>
                    </span>
                  </span>
                  <h4 className="white big margin-bottom10">
                    {isEn ? 'Donate' : 'Przekaż darowiznę'}
                  </h4>
                  <p className="roll-show">{isEn ? 'Click and pass donation to us' : 'kliknij i przekaż nam swoją pomoc' }</p>
                  <input className="hide" type="submit"/>
                </a>
                <h2>
                  <a
                    href="https://www.facebook.com/sasafoundation/"
                    className="white social-icon"
                  >
                    <i className="fa fa-facebook"/>
                  </a>
                  <a
                    href="https://twitter.com/sasa_foundation"
                    className="white social-icon"
                  >
                    <i className="fa fa-twitter"/>
                  </a>
                  <a
                    href="https://www.linkedin.com/company-beta/17908816/"
                    className="white social-icon"
                  >
                    <i className="fa fa-linkedin"/>
                  </a>
                  <a
                    href="https://www.instagram.com/sasafoundation/"
                    className="white social-icon"
                  >
                    <i className="fa fa-instagram"/>
                  </a>
                </h2>
              </form>
            </div>
          </div>
        </section>
        <form id="pay_form" method="post" name="payform"></form>
      </section>
    </Layout>
  )
}
